import { IIndexable } from 'core-ts-types';
import * as _4 from 'lodash4';

export interface IMetaMajor {
  id: number;
  nk: string;
  desc: string;
  title: string;
  _rank: number;
  _isRanked: boolean;
  _votes: number;
}

export interface IRankedMetaMajor {
  id: number;
  rank: number;
  student: number;
  metamajor_nk: string;
}

export class MetaRankingBuilder implements IIndexable {
  id: number;
  metamajor: IMetaMajor[];
  masterList: IMetaMajor[];
  toList: IMetaMajor[];
  fromList: IMetaMajor[];
  ranked_metamajors: IRankedMetaMajor[];
  _metamajor_sorted: IMetaMajor[];
  votes_by_metamajor: { [key: string]: number };
  _max: number;
  max_metamajors: number;
  maxList: number[];

  constructor(meta: MetaRankingBuilder) {
    meta._max = _4.isUndefined(meta.max_metamajors) ? 3 : meta.max_metamajors;
    this.setVotesOnMajor(meta);
    this.setMajorRanked(meta);
    this.setRankingLists(meta);
    this.setMaxRanking(meta);
    _4.merge(this, meta);
  }

  static build(meta: MetaRankingBuilder): MetaRankingBuilder {
    return new MetaRankingBuilder(meta);
  }

  setVotesOnMajor(meta: MetaRankingBuilder): void {
    _4.forEach(meta.votes_by_metamajor, (vote: number, name: string) => {
      const metamajor = _4.find(meta.metamajor, { nk: name });
      if (metamajor) {
        metamajor._votes = vote;
      }
    });

    meta._metamajor_sorted = _4.sortBy(_4.toArray(meta.metamajor), '_votes');
  }

  setMajorRanked(meta: MetaRankingBuilder): void {
    _4.forEach(meta.ranked_metamajors, (rankedMajor: IRankedMetaMajor) => {
      const metamajor = meta.metamajor[rankedMajor.id];
      if (metamajor) {
        metamajor._isRanked = true;
        metamajor._rank = rankedMajor.rank;
      }
    });
  }

  setRankingLists(meta: MetaRankingBuilder): void {
    meta.masterList = _4.map(meta.metamajor);

    _4.forEach(meta.masterList, (option: any, i: number) => {
      option.idx = i;
      option.drag = true;
      option.action = {
        option: option.id,
        value: 0
      };
    });

    meta.toList = _4.sortBy(_4.filter(meta.masterList, { _isRanked: true }), '_rank');
    meta.fromList = _4.sortBy(
      _4.filter(meta.masterList, (metaMaj: IMetaMajor) => !metaMaj._isRanked),
      'title'
    );
    meta.masterList = _4.sortBy(meta.masterList, 'title');
  }

  setMaxRanking(meta: MetaRankingBuilder): void {
    meta.maxList = _4.range(0, meta._max);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/builders/major_metaranking_builder.ts